var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(searchResult,index){return _c('SearchResult',{key:index,attrs:{"search-result":searchResult}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }